import '../../scss/pages/home.scss';
import { renderImagePopup } from "../libraries/ImagePopup";

function bindImagePopupHandler() {
    const anchors = document.querySelectorAll('a.gallery');

    for (let anchor of anchors) {
        const imageUrl = anchor.getAttribute('href');

        anchor.addEventListener('click', event => {
            event.preventDefault();
            renderImagePopup(imageUrl)
        });
    }

    return this;
}

function initialize() {
    bindImagePopupHandler();
}

initialize();
